import { combineReducers, createStore } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension/developmentOnly';

import sidebarReducer from 'store/sidebar/reducer';
import { ISidebarState } from 'store/sidebar/types';

export interface IAppState {
    sidebar: ISidebarState;
}

const reducers = {
    sidebar: sidebarReducer
};

function configureStore(initialState = {}) {
    const rootReducer = combineReducers<IAppState>(reducers);

    const store = createStore(rootReducer, initialState, devToolsEnhancer({}));

    return store;
}

export default configureStore;
